import {
  Typography,
  useTheme,
  useMediaQuery,
  Paper,
  Button,
} from "@mui/material";
import AccordionSection from "../../shared/accordionSection";
import SimpleTable from "../../shared/simpleTable";
import { TableColumnAlign } from "@/app/models/common/tableColumnAlign";
import { useNavigate } from "react-router-dom";
import RelatedQuote from "@/app/interfaces/RelatedQuote";

const TITLE = "Related Quotes";

const HEADERS = [
  "Quote Date",
  "Quote #",
  "Quote Job No",
  "Quote Total",
  "Details",
];

const ALIGN: TableColumnAlign[] = [
  "center",
  "center",
  "center",
  "center",
  "center",
];

const RelatedQuotes = ({
  relatedQuotes,
}: {
  relatedQuotes: RelatedQuote[];
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const rows = relatedQuotes.map((quote) => [
    new Date(quote.createdDate).toLocaleDateString(),
    quote.fullOrderNumber,
    quote.jobName,
    `$${quote.totalPrice.toFixed(2)}`,
    <Button
      onClick={() => navigate(`/order/details/${quote.id}`)}
      sx={{ fontSize: "0.875rem", fontWeight: 600 }}
    >
      DETAILS
    </Button>,
  ]);

  const content = (
    <Paper sx={{ mt: 1, p: isMobile ? 1 : 3 }}>
      {!isMobile && (
        <Typography
          variant="subtitle1"
          fontWeight={600}
          color="text.secondary"
          mb={2}
        >
          {TITLE}
        </Typography>
      )}

      <SimpleTable headers={HEADERS} rows={rows} align={ALIGN} />
    </Paper>
  );

  return isMobile ? (
    <AccordionSection title={TITLE}>{content}</AccordionSection>
  ) : (
    content
  );
};

export default RelatedQuotes;
